<template>
  <a-modal
    width="1000px"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @cancel="handleCancel"
    @ok="handleOk"
    okText="保存"
  >
    <a-row :gutter="24">
      <a-col :span="8">
        <from-render
          ref="render"
          :form="modifyModal.form"
          :model="modifyModal.form.model"
          :options="modifyModal.options"
          :validateInfos="modifyModal.validateInfos"
        />
      </a-col>
      <a-col :span="16">
        <label title="退货详情">退货详情</label>
        <a-table
          :scroll="{ y: 400 }"
          :columns="state.obj.columns"
          row-key="id"
          :data-source="state.obj.dataSource"
          :pagination="false"
        >
          <template v-for="col in ['num']" #[col]="{ record }" :key="col">
            <a-input v-model:value="record[col]" style="margin: -5px 0" />
          </template>
        </a-table>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { message, Modal } from 'ant-design-vue';
import { reactive } from 'vue';
import { create_order_used_cancel_record } from '@/api/mjstore-model';
import { query_product_out_record_list } from '@/api/mjstock-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { event_obj } from '@/components/page-model/mjstore/mjstore-orderrecord-config';
import moment from 'moment';
import { RuleObject } from 'ant-design-vue/lib/form/interface';
import { useForm } from 'ant-design-vue/es/form';
export default defineComponent({
  name: 'Orderusedrecordmodel',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    obj: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const loading = ref(false);
    const formModel: any = reactive({
      org_id: current_org?.id,
      order_used_record_id: props.obj?.order_used_record_id,
      shop_id: props.obj?.shop_id,
      staff_id: props.obj?.staff_id,
      date: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
    const modifyModal = {
      title: '退货',
      form: {
        settings: {
          labelAlign: 'right',
          layout: 'vertical',
        },
        fields: [
          {
            type: 'number',
            name: 'num',
            label: '退单单数',
            disabled: false,
            allowClear: true,
            defaultValue: '',
            placeholder: '请填退单单数',
          },
          {
            type: 'remoteselect',
            name: 'shop_id',
            label: '执行门店',
            disabled: !!current_shop,
            placeholder: '请选择执行门店',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-shop',
          },
          {
            type: 'remoteselect',
            name: 'staff_id',
            label: '执行人',
            disabled: false,
            placeholder: '请选择执行人',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            modalType: 'mjstore-staff',
          },
          {
            type: 'datepicker',
            name: 'date',
            label: '退货日期',
            disabled: false,
            allowClear: true,
            inputType: 'number',
            defaultValue: '',
            format: 'YYYY-MM-DD HH:mm:ss',
            valueFormat: 'YYYY-MM-DD HH:mm:ss',
            showTime: true,
            placeholder: '请选择退货日期',
          },
          {
            type: 'textarea',
            name: 'mark',
            label: '备注',
            disabled: false,
            allowClear: true,
            inputType: 'text',
            maxlength: 300,
            defaultValue: '',
            placeholder: '请填写备注',
          },
        ],
        rules: {
          num: [
            { required: true, message: '请填退单单数' },
            {
              validator: async (rule: RuleObject, value: number) => {
                if (value > props.obj.order_used_record__num) {
                  return Promise.reject(
                    '退货数量不能大于耗单数量:' + props.obj.order_used_record__num,
                  );
                } else {
                  return Promise.resolve();
                }
              },
              trigger: 'change',
            },
          ],
          shop_id: [{ required: true, message: '请选择执行门店' }],
          staff_id: [{ required: true, message: '请选择执行人' }],
          date: [{ required: true, message: '请选择退货日期' }],
        },
        model: formModel,
      },
      validateInfos: {},
      options: {},
    };
    const { validate, validateInfos } = useForm(formModel, modifyModal.form.rules);
    modifyModal.validateInfos = validateInfos;
    const dataSource: Array<any> = reactive([]);
    const state = {
      obj: {
        columns: [
          {
            title: '单据编号',
            dataIndex: 'code',
            key: 'code',
            width: '50%',
            slots: { customRender: 'code' },
          },
          {
            title: '名称',
            dataIndex: 's_product__name',
            key: 'name',
            width: '50%',
            slots: { customRender: 'name' },
          },
          {
            title: '数量',
            dataIndex: 'num',
            key: 'num',
            width: '50%',
            slots: { customRender: 'num' },
          },
          {
            title: '单位',
            dataIndex: 's_product__dw',
            key: 's_product__dw',
            width: '50%',
            slots: { customRender: 's_product__dw' },
          },
          {
            title: '操作',
            width: 100,
            dataIndex: 'action',
            slots: { customRender: 'action' },
          },
        ],
        dataSource: dataSource,
      },
    };
    if (props.obj?.order_used_record_id > 0) {
      query_product_out_record_list({
        org_id: current_org.id,
        order_used_record_id: props.obj?.order_used_record_id,
        page_index: 1,
        page_size: 2000,
        is_active: true,
      }).then((res: any) => {
        state.obj.dataSource.length = 0;
        res.data.map((item: any, index: any) => {
          item.unique_key = new Date().getTime() + index;
          item.num = item.remain_num;
          state.obj.dataSource.push(item);
        });
      });
    }
    const handleCancel = () => {
      emit('cancel');
    };
    const handleOk = () => {
      validate().then(() => {
        loading.value = true;
        const product_out_record_list: any[] = [];
        state.obj.dataSource.forEach((item: any) => {
          product_out_record_list.push({ id: item.id, num: item.num });
        });
        create_order_used_cancel_record({
          org_id: current_org.id,
          ...formModel,
          order_used_record_id: props.obj?.order_used_record_id,
          product_out_record_json: JSON.stringify(product_out_record_list),
        })
          .then(() => {
            message.success('退货成功');
            emit('ok');
            event_obj.emit('refresh');
          })
          .finally(() => {
            loading.value = false;
          });
      });
    };
    return {
      // fullscreen
      message,
      // edit
      loading,
      state,
      modifyModal,
      handleCancel,
      handleOk,
    };
  },
});
</script>
